import { render, staticRenderFns } from "./Disposal.vue?vue&type=template&id=7b134586"
import script from "./Disposal.vue?vue&type=script&lang=js"
export * from "./Disposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports